import './tripsDetails.css';
import {Link} from "react-router-dom";
import TripsList from "../../components/tripsComponent/allTrips/tripsList/tripsList";
import DriverInfo from "../../components/driverInfo/driverInfo";
import VideoSec from "../../components/videoSec/videoSec";

import TripFactorDetails from "../../components/tripFactorDetails/tripFactorDetails";
import TripStops from "../../components/tripStops/tripStops";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import DvrVideoPlayer from "../../components/dvrVideoPlayer/dvrVideoPlayer";
import {useEffect, useState} from "react";
import Slider from "../../shared/slider/slider";
import TripDetailsMap from "../../components/tripDetailsComponent/tripDetailsMap/tripDetailsMap";
import mapData from "../../data/mapData";

const TripsDetails = () => {
    const [selectedStep, setSelectedStep] = useState();
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [DVRVideoPathNodes, setDVRVideoPathNodes] = useState([]);
    const [DVRPathSliderNodes, setDVRPathSliderNodes] = useState([1, 3]);

    const getSelectedTripStep = (step) => {
        setSelectedStep(step);
    }

    const driverInfo = [
        {
            text: 'Ramesh Jagannath',
            class: 'sf-bold'
        },
        {
            text: 'ID: 6885',
            class: ''
        },
        {
            text: 'Alertness: Good',
            class: ''
        },
        {
            text: 'BharathBenz HDT R  - 30 Tons',
            class: 'sf-bold'
        },
        {
            text: 'KA 02  N 9023',
            class: ''
        },
        {
            text: 'Model: 2017 ',
            class: ''
        },
    ];
    const handleShowVideoPlayer = (val) => {
        setShowVideoPlayer(val);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }
    const getDVRVideoPath = (nodes) => {
        getDVRVideoPathNodes(nodes);
    }

    const getDVRVideoPathNodes = (nodes) => {
        const DVRVideoNodes = [];
        for (let i = nodes[0]; i <= nodes[1]; i++) {
            DVRVideoNodes.push(mapData.cords[i]);
        }
        setDVRVideoPathNodes(DVRVideoNodes);
    }

    useEffect(() => {
        getDVRVideoPathNodes([1, 3]);
    }, [])



    return (
        <div className={'content-section trip-details-sec page-fade-in'}>
            <div className="round-corner-8 padding-tb-20 flex hr-space-between border-bottom">
                <Link to=".." relative={'path'} className="flex font-15 gap-10">
                    <div className="back-btn-circular"></div>
                    <div className="highlight-color sf-medium">Back</div>
                </Link>
                <div className="flex">
                    <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>
            </div>

            <div className="">
                <TripsList classes={'trip-details-list'} data={[1]}/>
            </div>

            {/*....... driver details .......*/}
            <div className="border-bottom margin-b-40"><DriverInfo data={driverInfo}/></div>

            {/*....... video section ......*/}
            <div className="margin-b-40">
                <div className="section-title margin-b-20">Critical Alert Videos</div>
                <VideoSec/>
            </div>

            <div className="trip-map-sec">
                <div className="section-title margin-b-20">Map</div>
                <div className="flex align-top">
                    <div className="map-sec relative">
                        <ul className={'trip-list map-overlay font-14'}>
                            <li className={'flex hr-space-between sf-medium'}>
                                <div className={'flex gap-50'}>
                                    <div className="flex gap-10 font-15">
                                        <div className={'from'}>Bangalore</div>
                                        <div className="connector"></div>
                                        <div className="to">Chennai</div>
                                    </div>
                                    <div className="">
                                        Driver: Babu K
                                    </div>
                                </div>
                                <ul className="separator font-14 gap-20">
                                    <li>289 kms</li>
                                    <li>4.3 Hrs</li>
                                </ul>
                                <div className="btn item-height-40 round-corner-8 font-14"
                                     onClick={e => handleShowVideoPlayer(true)}>
                                    Request DVR Video
                                </div>
                            </li>
                        </ul>
                        <div className="trip-details-map margin-b-20">
                            <TripDetailsMap
                                DVRVideoPathNodes={DVRVideoPathNodes}
                                getSelectedTripStep={getSelectedTripStep}
                                activeStep={selectedStep}/>
                        </div>
                        <div className="map-slider">
                            <Slider min={0}
                                    max={mapData.cords.length - 1}
                                    range={true}
                                    onChange={getDVRVideoPath}
                                    value={DVRPathSliderNodes}/>
                        </div>
                    </div>
                    <div className="trip-info-sec">
                        <div className="margin-b-30"><TripFactorDetails/></div>
                        <div className="">
                            <TripStops
                                getSelectedTripStep={getSelectedTripStep}
                                activeStep={selectedStep}/>
                        </div>
                    </div>
                </div>
            </div>
            {showVideoPlayer &&
                <DvrVideoPlayer handleShowVideoPlayer={handleShowVideoPlayer}/>
            }
        </div>
    )
}

export default TripsDetails;
